//
// ImageDataPolicy.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var ImageDataPolicy = {
    RUNTIME_DEFAULTS:0,
    RETAIN_FILE_BLOB:1,
    RETAIN_DECODED_BITMAP:2,
    CONVERT_TO_TEXTURE:4,
    ACQUIRE_AS_TEXTURE_ONLY:8,
    ENABLE_MIPMAP:16,
    DECODE_AS_BGRA_EXT:32
};
export default ImageDataPolicy;
